import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from './utils/auth';

export default function LogoutRoute() {
    const navigate = useNavigate();
    useEffect(() => {
        (async () => {
            try {
                await logout();
            } finally {
                navigate('/', { replace: true });
            }
        })();
    }, [navigate]);
    return null;
}


